import BipolarSelfTest from './BipolarSelfTest';

export default BipolarSelfTest;
